export const Color_White = '#ffffff';
export const Color_Light = '#f3f4f8';
export const Color_Grey = '#181818';
export const Color_Black = '#000000';
export const Color_Blue = '#243f7c';
export const Color_Yellow = '#fdcc09';
export const Color_BrandBlue = '#005d93';
export const Color_BrandOrange = '#e73c1e';
